import { ComponentPropsWithoutRef } from 'react'
import cx from 'helpers/cx'

import styles from './NotificationHighlight.module.css'

type NotificationHighlightProps = ComponentPropsWithoutRef<'span'> & {
    $isBold?: boolean
}

export default function NotificationHighlight({
    $isBold,
    className,
    ...rest
}: NotificationHighlightProps) {
    return (
        <span
            className={cx(
                styles.highlight,
                $isBold && styles.isBold,
                className,
            )}
            {...rest}
        />
    )
}
